export const TimerFactory = (ms: number): Timer => {
	let id;

	const tickTock = () =>
		new Promise((resolve) => {
			if (id === -1) {
				throw new Error('Timer already aborted');
			}

			id = setTimeout(resolve, ms);
		});

	const abort = () => {
		if (id !== -1 || id === undefined) {
			clearTimeout(id);
			id = -1;
		}
	};

	return {
		tickTock,
		abort,
	};
};

export interface Timer {
	tickTock(): Promise<unknown>;
	abort(): void;
}
